<template>
    <div id="app">
        <div>
            <transition name="routerViewAnimation">
                <router-view></router-view>
            </transition>
        </div>
        <audioComponent></audioComponent>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
import audioComponent from "@/components/audioComponent";
// import { requestHmlWx } from "@/assets/hmlapi.js";
// import Vconsole from 'vconsole';
// new Vconsole();
export default {
    data(){
        return {
            wxshareData: {
                title: "慢游京山",
                desc: "慢游京山",
                link: "http://www.hmltec.com/720/jingshan/index.html",
                imgUrl: "http://www.hmltec.com/720/jingshan/logo.png"
            }
        }
    },
    created(){
        this.obtainData();
        let src = decodeURI(location.search); //获取url中"?"符后的字串
        let theRequest = new Object();
        if (src.indexOf("?") != -1) {
            let str = src.substr(1);
            let strs = str.split("&");
            for(let i = 0; i < strs.length; i ++) {
                theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
            }
        }
        
        let { firstLevelIndex,levelThreeIndex,secondLevelIndex,url } = theRequest;
        
        // console.log(url.split("/")[1]);
        if(!this.urlFlag){
            let time = setInterval(() => {
                if(this.pageShow){
                    clearInterval(time);
                    if(levelThreeIndex){
                        this.setIndex({firstLevelIndex,levelThreeIndex,secondLevelIndex});
                        if(firstLevelIndex == 3 && (secondLevelIndex == 0 || secondLevelIndex == 1)){
                            
                        }else{
                            this.setUrlFlag();
                        }
                    }else if(secondLevelIndex){
                        this.setIndex({firstLevelIndex,secondLevelIndex});
                        this.setUrlFlag();
                    }
                    if(url){
                        console.log(url);
                        this.$router.push({name: url.split("/")[1]});
                    }
                    
                }
            },100);
            
        }
        
    },
    mounted(){
         const GetRequest = () => {
            let url = decodeURI(location.search); //获取url中"?"符后的字串
            let theRequest = new Object();
            if (url.indexOf("?") != -1) {
                let str = url.substr(1);
                let strs = str.split("&");
                for(let i = 0; i < strs.length; i ++) {
                    theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
        let { firstLevelIndex,secondLevelIndex,levelThreeIndex } = GetRequest();
        if(firstLevelIndex){
            this.setIndex({firstLevelIndex});
            if(secondLevelIndex){
                this.setIndex({secondLevelIndex});
                if(levelThreeIndex){
                    this.setIndex({levelThreeIndex});
                }
            }
        }
    },
    methods: {
        ...publicData.mapMutations(["obtainData","setIndex","setUrlFlag"]),
    },
    computed: {
        ...publicData.mapState(["pageShow","allData","firstLevelIndex","secondLevelIndex","levelThreeIndex","specialtyState","staticeData","urlFlag"])
    },
    components: {
        audioComponent
    },
    watch: {
        '$route.path': function (newVal, oldVal) {
             /* if(newVal != "/index"){
                 if(newVal == "/impression" || newVal == "/jingtan" || newVal == "/food" || newVal == "/feiyi" || newVal == "/renjie" || newVal == "/ScenicArea" || newVal == "/rural" || newVal == "/redTourism" || newVal == "/night" || newVal == "/route" || newVal == "/hotel" || newVal == "/homestay" || newVal == "/restaurant" || newVal == "/shopping" || newVal == "/travel"|| newVal == "/map"){
                    // console.log(this.firstLevelIndex,this.secondLevelIndex);
                    let obj = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex];
                    this.wxshareData.title = obj.title;
                    this.wxshareData.link = window.location.href.split("?")[0] + "?firstLevelIndex="+ this.firstLevelIndex +"&secondLevelIndex=" + this.secondLevelIndex + "&url=" + newVal;
                }else{
                    let obj = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[this.levelThreeIndex];
                    this.wxshareData.title = obj.title;
                    this.wxshareData.link = window.location.href.split("?")[0] + "?firstLevelIndex="+ this.firstLevelIndex +"&secondLevelIndex=" + this.secondLevelIndex + "&levelThreeIndex=" + this.levelThreeIndex + "&url=" + newVal;
                }
                let wxshareData = this.wxshareData;
                // console.log(wxshareData);
                wx.onMenuShareAppMessage({
                        title: wxshareData.title, // 分享标题
                        link: wxshareData.link, // 分享链接
                        imgUrl: wxshareData.imgUrl, // 分享图标
                        desc: wxshareData.desc, // 分享描述
                        success () {
                            console.log("成功");
                        },
                        cancel () {
                            console.log("失败");
                        }
                    });
                    wx.onMenuShareTimeline({
                        title: wxshareData.title, // 分享标题
                        link: wxshareData.link, // 分享链接
                        imgUrl: wxshareData.imgUrl, // 分享图标
                        desc: wxshareData.desc, // 分享描述
                        success () {
                            console.log("成功");
                        },
                        cancel () {
                            console.log("失败");
                        }
                    })
             }else{
                 let obj = {
                    "title": "慢游京山",
                    "desc": "网球之乡，生态京山",
                    "link": "http://www.hmltec.com/720/jingshan/index.html",
                    "imgUrl": "http://www.hmltec.com/720/jingshan/logo.png"
                };
                  wx.onMenuShareAppMessage({
                        title: obj.title, // 分享标题
                        link: obj.link, // 分享链接
                        imgUrl: obj.imgUrl, // 分享图标
                        desc: obj.desc, // 分享描述
                        success () {
                            console.log("成功");
                        },
                        cancel () {
                            console.log("失败");
                        }
                    });
                    wx.onMenuShareTimeline({
                        title: obj.title, // 分享标题
                        link: obj.link, // 分享链接
                        imgUrl: obj.imgUrl, // 分享图标
                        desc: obj.desc, // 分享描述
                        success () {
                            console.log("成功");
                        },
                        cancel () {
                            console.log("失败");
                        }
                    })
             } */
             
        }
        
        // firstLevelIndex(nv){
        //     if(nv != -1){
        //         let obj = this.allData[nv].dataArr[this.secondLevelIndex];
        //         //  console.log("一及索引改变了，新的是==>",nv);
        //         this.wxshareData.title = obj.title;
        //         this.wxshareData.link = window.location.href + "?firstLevelIndex="+ nv +"&secondLevelIndex=" + this.secondLevelIndex;
        //         requestHmlWx(this.wxshareData);
        //     }else{
        //         requestHmlWx(this.staticeData.option.wxshareData);
        //     }
        // },
        // secondLevelIndex(nv){
        //     if(this.firstLevelIndex == -1){
        //         return;
        //     }
        //     // console.log("二及索引改变了，新的是==>",nv);
        //     if(nv != 0){
        //         let obj = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex];
        //          // console.log(this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].title);
        //         this.wxshareData.title = obj.title;
        //         this.wxshareData.link = window.location.href + "?firstLevelIndex="+ this.firstLevelIndex +"&secondLevelIndex=" + nv;
        //         requestHmlWx(this.wxshareData);
        //     }
        // },
        // levelThreeIndex(nv){
        //     if(this.firstLevelIndex == -1){
        //         return;
        //     }
        //     // console.log("三及索引改变了，新的是==>",nv);
        //     let obj = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[nv];
        //      // console.log(this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].title);
        //     this.wxshareData.title = obj.title;
        //     this.wxshareData.link = window.location.href + "?firstLevelIndex="+ this.firstLevelIndex +"&secondLevelIndex=" + this.secondLevelIndex + "&levelThreeIndex=" + nv;
        //     requestHmlWx(this.wxshareData);
        // },
    }
};
</script>

<style lang="scss">
#app {
	width: 100%;
	height: 100%;
}
.routerViewAnimation-enter,.routerViewAnimation-leave-to {
	opacity: 0;
}
// 控制元素显示过程中实现的具体动画效果
.routerViewAnimation-enter-active,.routerViewAnimation-leave-active {
	transition: all .3s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.routerViewAnimation-enter-to,.routerViewAnimation-leave {
	opacity: 1;
}
</style>
